export default __webpack_public_path__ + "static/media/premiseIcon.76d037e7.svg";